import { hgNumber, HgSupportedLanguage } from '@smg-real-estate/domus';
import isNil from 'lodash.isnil';

export const formatLocalizedNumber = (
  value: number | null | undefined,
  rounded: boolean,
  locale: HgSupportedLanguage,
): string => {
  if (isNil(value)) {
    return '';
  } else {
    const num = rounded ? Math.round(value / 100) * 100 : value;
    return hgNumber(num, locale);
  }
};
